import React from "react";

const stats = [
    { value: "350+", label: "Internships" },
    { value: "100+", label: "Students Placed Successfully" },
    { value: "50+", label: "Industry Recruiters Engaged" },
    { value: "₹7.5L+ LPA", label: "Highest Package Offered" },
];

export default function Stats() {
    return (
        <section
            data-testid="stats-section"
            className="relative py-20 sm:py-24 md:py-32 overflow-hidden"
            style={{ background: "#2e326b" }}
        >
            {/* Decorative accents */}
            <div
                className="pointer-events-none absolute -top-32 right-0 w-[420px] h-[420px] rounded-full opacity-30 blur-3xl"
                style={{
                    background:
                        "radial-gradient(circle, rgba(255,192,4,0.4) 0%, transparent 70%)",
                }}
            />

            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 md:px-10">
                <div className="max-w-2xl mb-12 sm:mb-16 md:mb-20">
                    <h2
                        className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight tracking-tight text-white"
                        data-testid="stats-heading"
                    >
                        Excellence In Numbers
                    </h2>
                    <div
                        className="mt-5 h-[3px] w-16 sm:w-20"
                        style={{ background: "#ffc004" }}
                    />
                </div>

                <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-10 sm:gap-y-14 gap-x-4 sm:gap-x-6 md:gap-x-10 relative">
                    {stats.map((s, idx) => (
                        <div
                            key={idx}
                            data-testid={`stat-item-${idx}`}
                            className={`relative px-1 sm:px-2 md:px-6 ${
                                idx !== stats.length - 1
                                    ? "lg:border-r lg:border-white/15"
                                    : ""
                            }`}
                        >
                            <div
                                className="font-extrabold leading-none tracking-tight text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl whitespace-nowrap"
                                style={{ color: "#ffc004" }}
                            >
                                {s.value}
                            </div>
                            <p className="mt-3 sm:mt-4 text-xs sm:text-sm md:text-base leading-relaxed max-w-[220px] text-white/85">
                                {s.label}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
